<template>
    <b-card header-class="pr-2" class="notes" header="Notes" body-class="notes__body p-0" footer-class="p-1">
        <template v-slot:header>
            <i v-if="isLoading" class="float-left fa-solid fa-2x fa-spin fa-spinner mr-1"></i>
            <b-form-row>
                <b-col>
                    <span class="h5">Notes</span>
                    <i v-b-tooltip.hover
                       title="Close Notes"
                       class="fa-solid fa-window-close px-1 mt-2 mr-0 pointer text-danger float-right"
                       v-if="$parent.closeNotes"
                       @click="$parent.closeNotes">
                    </i>
                    <span class="float-right">
                        <i v-b-tooltip.hover
                           :title="notesExpand ? 'Compress Notes':'Expand Notes'"
                           class="fa-solid mt-2 mr-2 ml-1 mb-2 pointer"
                           v-if="$parent.closeNotes"
                           :class="notesExpand ? 'fa-compress-arrows-alt':'fa-expand-arrows-alt' "
                           @click="expandNotes">
                        </i>
                    </span>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col>
                    <div class="d-flex align-items-center">
                        <b-form-checkbox
                                style="line-height:
                                                    2.5; height: 0"
                                class="pt-1"
                                v-model="showAllOrders"
                                id="all_orders">All Orders
                        </b-form-checkbox>
                    </div>

                </b-col>
                <b-col>
                    <b-form-select
                            style="font-size: 12px;
                                            line-height: 1"
                            size="sm"
                            class="pull-right p-1"
                            @change="noteOptionChange"
                            v-model="openOptionSelected"
                            :options="openOptions">
                    </b-form-select>
                </b-col>
            </b-form-row>

        </template>

        <div class="mb-1" v-for="item in notes" :key="item.id" v-if="canDisplay(item)">
            <div class="note-header-bg pointer py-1 px-2" @click="toggleNotes(item.id)" :id="'notes_id_'+item.id">
                <i :class="['fa-solid mr-1', item.order_id ? 'fa-archive text-warning' : 'fa-user text-danger']" aria-hidden="true"></i>
                <span class="font-weight-bold">{{ item.created_at | datetime  }}</span> | {{ item.creator_name || "System" }} |
                <span class="font-weight-bold"><span v-if="item.order_id">Order: </span>{{ item.order_id || 'Customer' }}</span>
                <i class="fa-solid float-right notes-carat" :class="!item.creator_name || item.creator_name == 'System' ? 'fa-plus-square':'fa-minus-square' "></i>
            </div>
            <div class="note-details"
                 :data-name="item.creator_name"
                 :class="!item.creator_name || item.creator_name == 'System' ? 'd-none' : '' ">
                <div class="p-1 note-body-bg pl-4" v-html="item.contents"></div>
                <div class="m-1 clearfix">

                </div>
            </div>
        </div>


        <template v-slot:footer>
            <b-input-group>
                <template v-slot:prepend>
                    <b-input-group-text class="d-flex flex-column">
                        <i v-if="!isSaved" class="fa-solid fa-pen-square note-icons"></i>
                        <i v-else class="fa-solid fa-check-circle text-success"></i>
                        <template v-if="newNoteValue == true && isSaving == false">
                            <i class="note-icons clickable fa-solid fa-save text-success my-2" @click="saveNote"></i>
                            <i class="note-icons clickable fa-solid fa-times-circle text-danger" @click="cancelNote"></i>
                        </template>
                        <i v-if="isSaving" class="note-icons fa-solid fa-spinner fa-spin mt-1"></i>
                    </b-input-group-text>
                </template>
                <b-form-textarea
                        class="notes-input"
                        :class="creatingNote ? 'notes-input-open': '' "
                        placeholder="Add note..."
                        v-model="newNote"
                        @focus.native="handleFocus">
                </b-form-textarea>
            </b-input-group>
        </template>
    </b-card>
</template>

<script>
    import {SYNC_USER} from "@/store/actions";
    import _ from 'lodash';
    export default {
        name: 'NotesPopup',
        props: {
            customer_id: Number,
            order_id: Number,
            user: String,
        },
        data() {
            return {
                oldOrder: false,
                oldCustomer: false,
                notesExpand: false,
                isLoading: false,
                isSaved: false,
                isSaving: false,
                notesOpen: false,
                creatingNote: false,
                newNote: '',
                info: null,
                notes: [],
                openOptions: ['All Notes', 'User Notes', 'System Notes'],
                openOptionSelected: 'All Notes',
                showAllOrders: false,
            };
        },
        mounted() {
            this.updateScroll()
        },
        created() {
            this.getNotes();
        },
        watch: {
            order_id(newer, older){
                if(newer != older) {
                    this.leaveBroadcastChannel();
                    this.getNotes();
                }
            },
            customer_id(newer, older){
                if(newer != older) {
                    this.leaveBroadcastChannel();
                    this.getNotes();
                }
            },
            notesOpen(){
                this.updateScroll();
            },
            showAllOrders() {
                this.noteOptionChange(this.openOptionSelected);
            },
            _isFlagUpdated: {
                immediate: true,
                deep: true,
                handler(flag) {
                    //this.getNotes();
                }
            }
        },
        computed: {
            newNoteValue() {
                return this.newNote != '';
            },
            isValidLookup(){
                return (this.order_id || this.order_id === 0) && (this.customer_id || this.customer_id === 0);
            },
            _isFlagUpdated () {
                return this.$store.getters.updatedFlag;
            },
        },
        methods: {
            updateScroll() {
                var _this = this;
                this.$nextTick(function(){
                    let notesBody = document.querySelector('.notes__body');
                    //console.log('notes body :', notesBody);
                    if (notesBody != null) {
                        notesBody.scrollTop = notesBody.scrollHeight;
                    }
                });
            },
            toggleNotes(id) {
                let note = document.querySelector('#notes_id_'+id);
                note.nextSibling.classList.toggle('d-none');
                let notesCarat = note.querySelector('.notes-carat');
                if(notesCarat.classList.contains('fa-plus-square') ) {
                    notesCarat.classList.remove('fa-plus-square');
                    notesCarat.classList.add('fa-minus-square');
                } else {
                    notesCarat.classList.remove('fa-minus-square');
                    notesCarat.classList.add('fa-plus-square');
                }
                //this.openOptionSelected = 'Custom';
            },
            openNotesWidget() {
                this.notesOpen = !this.notesOpen;
            },
            createNote() {
                this.creatingNote = !this.creatingNote;
            },
            handleFocus() {
                this.creatingNote = true;
            },
            expandNotes() {
                let note = document.querySelector('.notes');
                let noteBody = document.querySelector('.notes__body');
                note.classList.toggle('expand');
                noteBody.classList.toggle('expand');
                this.notesExpand = !this.notesExpand;
            },
            noteOptionChange(e) {
                this.$nextTick( ()=> {
                    this.notes.forEach((noteData) => {
                        let base = document.querySelector('#notes_id_' + noteData.id);
                        if(base) {
                            //console.log(base, e);
                            let item = base.nextSibling;
                            if (e == 'User Notes' || e == 'All Notes') {
                                if ((noteData.creator_name && noteData.creator_name != 'System')) {
                                    item.classList.remove('d-none');
                                } else {
                                    item.classList.add('d-none');
                                }
                            } else if (e == 'All Orders') {
                                if (!noteData.order_id) {
                                    item.classList.add('d-none');
                                } else {
                                    item.classList.remove('d-none');
                                }
                            } else if (e == 'Customer Only') {
                                if (!noteData.customer_id) {
                                    item.classList.add('d-none');
                                } else {
                                    item.classList.remove('d-none');
                                }
                            } else if (e == 'Current Order') {
                                if (noteData.order_id && noteData.order_id == this.order_id) {
                                    item.classList.remove('d-none');
                                } else {
                                    item.classList.add('d-none');
                                }
                            } else if (e == 'System Notes') {
                                if ((noteData.creator_name && noteData.creator_name != 'System')) {
                                    item.classList.add('d-none');
                                } else {
                                    item.classList.remove('d-none');
                                }
                            } else if (e == 'All') {
                                item.classList.remove('d-none');
                            } else {
                                item.classList.add('d-none');
                            }

                            let a = base;
                            if (item.classList.contains('d-none')) {
                                a.querySelector('.notes-carat').classList.add('fa-plus-square');
                                a.querySelector('.notes-carat').classList.remove('fa-minus-square');
                            } else {
                                a.querySelector('.notes-carat').classList.remove('fa-plus-square');
                                a.querySelector('.notes-carat').classList.add('fa-minus-square');
                            }
                        }
                    });
                });
            },
            canDisplay(item){
                if((this.showAllOrders || (item.order_id == this.order_id)) || item.customer_id){
                    switch(this.openOptionSelected){
                        case 'User Notes':
                            return ((item.creator_name && item.creator_name != 'System'));
                        case 'System Notes':
                            return !((item.creator_name && item.creator_name != 'System'));
                        case 'All Notes':
                            return true;
                    }
                    return true;
                }
                return false;
            },
            addNote(a) {
                let that = this;
                let payload = {
                    contents: a,
                };
                this.$http.post("/orders/" + this.order_id + "/notes",payload)
                        .then(function(res){
                            var data = res.data.data;
                            that.notes.push(data);
                        })
                        .catch(function(){
                            window.alert("issue updating notes");
                        });
                this.$nextTick(function(){
                    let notesBody = document.querySelector('.notes__body');
                    notesBody.scrollTop = notesBody.scrollHeight;
                });
            },
            joinBroadcastChannel() {
                this.$store.dispatch(SYNC_USER, (profile) => {
                    console.info(String.fromCodePoint(0x1F514) + ' Joining App.Note.Customer.' + profile.id+ ' channel from NotesModule');
                    //this.profileCached = profile;
                    //'.'

                    this.$echo.channel('App.Notes.Customer.' + this.customer_id)
                        .listen('NoteWasCreated', this.updateNote)
                        .listen('NoteWasUpdated', this.updateNote)
                        .error((e) => {
                            console.log('ERROR OCCURRED', e);
                        });
                    this.oldOrder = this.order_id;
                    this.oldCustomer = this.customer_id;
                });
            },
            updateNote(event){
                //console.log("EVENT", event);
                let note = event.note;
                for(let i = 0; i < this.notes.length; i++) {
                    if(note.id == this.notes[i].id){
                        //todo delete functionality, but notes don't currently have the ability to do that.
                        this.notes[i] = note;
                        this.notes = _.clone(this.notes);
                        this.$forceUpdate();
                        return;
                    }
                }
                this.notes.push(note);
                this.notes = _.clone(this.notes);
                this.$forceUpdate();
            },
            leaveBroadcastChannel: function() {
                if(this.oldOrder || this.oldCustomer) {
                    //this.$echo.leaveChannel('App.Notes.Order.' + this.oldOrder);
                    this.$echo.leaveChannel('App.Notes.Customer.' + this.oldCustomer);
                    this.oldOrder = null;
                    this.oldCustomer = null;
                }
            },
            saveNote() {
               let that = this;
               this.isSaving = true;
                // You will need to update this payload
               let payload = {
                   //customer_id: this.customer_id,
                  // order_id: this.order_id,
                   contents: this.newNote,
                 //  created: new Date(),
                   //name: this.user,
               };

               // I created these timeout functions just create the saving/ features, update as you please.
                this.$http.post("/orders/" + this.order_id + "/notes",payload)
                    .then(function(res){
                        var data = res.data.data;
                        that.notes.push(data);
                        that.isSaving = false;
                        that.newNote = '';
                        that.creatingNote = false;
                        that.isSaved = true;
                        that.updateScroll();
                        //that.openOptionSelected = 'Custom';
                    })
                    .catch(function(){
                        that.isSaving = false;
                        window.alert("issue updating notes");
                    });
               // I used this just to post to my fake data
           },

            closeNotes() {
                this.notesOpen = !this.notesOpen;
                this.cancelNote();
            },
            cancelNote() {
                this.newNote = '';
                this.creatingNote = false;
            },


            // all dummie data, create your api call in here
            getNotes() {
                if(!this.isLoading && this.isValidLookup){
                    this.isLoading = true;
                    var _this = this;
                    this.$http.get("/customers/orders/" + this.customer_id + "/notes")
                        .then(function(res){
                            _this.joinBroadcastChannel();
                            _this.notes = res.data.data;
                            _this.isLoading = false;
                            _this.updateScroll();
                        }).catch(function(resp){
                            window.alert("issue loading notes");
                            _this.isLoading = false;
                        });
                }
            },
        }
    };
</script>

<style scoped>
    .notes-wrapper {
        position: fixed;
        bottom: 24px;
        right: 24px;
    }
    .notes,.notes__body {
        transition: .5s ease-in-out;
    }
    .notes {
        width:100%;
        max-width: 380px;
        animation-name: show;
        animation-duration: 1s;
        animation-timing-function: ease-out;
    }
    .notes.expand {
        max-width: 500px !important;
    }
    .notes__body {
        overflow: scroll;
        height: 300px;

    }
    .notes__body.expand {
        height: 600px;
    }
    .note-header-bg {
        background: #dfecf0;
        cursor: pointer;
    }
    .note-body-bg {
        background: #ddd;
    }
    .notes-toggle-btn {
        box-shadow: 0 4px 10px -4px #333;
    }
    .notes-input {
        transition: .2s ease-in-out;
        height: 36px;
    }
    .notes-input-open {
        height: 130px;
    }
    .pointer {
        cursor: pointer;
    }

    .note-icons {
        font-size: 16px;

    }
    .note-icons.clickable  {
        transition: .2s ease-in-out;
        cursor: pointer;
    }
    .note-icons.clickable:hover {
        transform: scale(1.3)
    }

    @keyframes show {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

</style>
